import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import deLocale from "date-fns/locale/de";
import { Container, PageTitle, TitleContainer } from "../../../components/refactor/components";
import ASMSButton from "../../../components/Button";
import { PencilIcon, SaveIcon } from "@heroicons/react/outline";
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    InputLabel,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    TextField
} from "@mui/material";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import React, { useEffect, useState } from "react";
import { useForm } from "@inertiajs/inertia-react";
import axios from "axios";

const WarehouseEntryForm = (props) => {
    const [open, toggleOpen] = useState(false);
    const [articles, setArticles] = useState(props.articles);
    const [articleErrors, setArticleErrors] = useState({});
    const [inputValue, setInputValue] = useState("");
    const [inputValueStorageLocation, setInputValueStorageLocation] = useState("");
    const filter = createFilterOptions();

    const isEditMode = Object.keys(props.initialState).length > 0;

    useEffect(() => {
        if (props.initialState) {
            setInputValue(props.initialState.article.name);
            setInputValueStorageLocation(
                props.storageLocations.filter(location => location.id === props.initialState.storage_location.id)[0].name
            );
        }
    }, []);

    const getFormData = () => {
        if (isEditMode) {
            const initialEntry = props.initialState;

            return {
                market: initialEntry.market_id,
                article: initialEntry.article.id,
                amount: initialEntry.amount,
                storageLocation: initialEntry.storage_location.id,
                storageType: initialEntry.storage_type,
                createdAt: initialEntry.created_at
            };
        }

        return {
            market: "",
            article: "",
            amount: 1,
            storageLocation: "",
            storageType: "PALLET",
            createdAt: null
        };
    };

    const getFormDataArticle = () => {
          if (isEditMode) {
              return {
                  id: props.initialState.article.id,
                  name: props.initialState.article.name,
                  eanNumber: props.initialState.article.eanNumber,
                  articleNumber: props.initialState.article.article_number,
                  manufacturer: props.initialState.article.manufacturer
              };
          }

        return {
            name: "",
            eanNumber: "",
            articleNumber: "",
            manufacturer: ""
        };
    };

    const { data, setData, post, put, processing, errors, transform } = useForm(getFormData());

    transform((data) => {
        return {
            ...data,
            article: Number.isInteger(data.article) ? data.article : data.article.id,
            amount: Number.isInteger(data.amount) ? data.amount : parseInt(data.amount)
        }
    });

    const createNewArticleForm = useForm(getFormDataArticle());

    const submit = () => {
        if (isEditMode) {
            return put(`/admin/warehouse/${props.initialState.id}`);
        } else {
            return post("/admin/warehouse");
        }


    };

    const createOrUpdateArticle = () => {
        let url = "/admin/warehouse/article";

        if (isEditMode) {
            url = `/admin/warehouse/article/${createNewArticleForm.data.id}`;
        }

        axios.post(url, createNewArticleForm.data)
            .then(async response => {
                setData("article", response.data.id);

                if (!isEditMode) {
                    createNewArticleForm.reset();
                }

                if (isEditMode) {
                    setInputValue(response.data.name);
                }

                const articles = await axios.get("/admin/warehouse/article");
                setArticles(articles.data);

                toggleOpen(false);
            })
            .catch(error => {
                if (error.response) {
                    setArticleErrors(error.response.data);
                }
            })
    };

    const getHelperTextByProperty = (property) => {
        const errorObject = articleErrors.errors || errors;

        if (errorObject === undefined) {
            return null;
        }

        if (errorObject[property] !== undefined) {
            return errorObject[property];
        }

        return null;
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={deLocale}>
            <div className="space-y-3">
                <Container>
                    <PageTitle
                        title={props.initialState.article.name}
                        buttons={[
                            <ASMSButton
                                IconComponent={SaveIcon}
                                type="primary"
                                onClick={submit}
                            >
                                Speichern
                            </ASMSButton>
                        ]}
                    />
                </Container>
                <TitleContainer title="Daten eingeben">
                    <div className="space-y-6">
                        <FormControl
                            variant="filled"
                            sx={{ width: 1 }}
                            error={!!getHelperTextByProperty("market")}
                        >
                            <InputLabel>Markt auswählen</InputLabel>
                            <Select
                                value={data.market}
                                onChange={e => setData("market", e.target.value)}
                                placeholder="Markt auswählen"
                                MenuProps={{ sx: { width: 1 } }}
                            >
                                {props.markets.map(market => (
                                    <MenuItem key={market.name + market.id} value={market.id}>{market.name}</MenuItem>
                                ))}
                            </Select>
                            {!!getHelperTextByProperty("market") && (
                                <FormHelperText>{getHelperTextByProperty("market")}</FormHelperText>
                            )}
                        </FormControl>

                        <FormControl
                            variant="filled"
                            sx={{ width: 1 }}
                            error={!!getHelperTextByProperty("article")}
                        >
                            <Autocomplete
                                inputValue={inputValue}
                                onInputChange={(event, newInputValue) => {
                                    setInputValue(newInputValue);
                                }}
                                renderInput={(params) => <TextField {...params}  variant="filled" label="Artikel suchen" />}
                                renderOption={(props, option) => <li {...props} key={option.id + option.name}>{option.name}</li>}
                                getOptionLabel={(option) => {
                                    if (typeof option === "string") return option;
                                    if (option.inputValue) return option.inputValue;
                                    return option.name;
                                }}
                                filterOptions={(options, params) => {
                                    const filtered = filter(options, params);

                                    if (params.inputValue !== '') {
                                        filtered.push({
                                            inputValue: params.inputValue,
                                            name: `"${params.inputValue}" neu anlegen`
                                        });
                                    }

                                    return filtered;
                                }}
                                onChange={(event, newValue) => {
                                    if (typeof newValue === "string") {
                                        setTimeout(() => {
                                            toggleOpen(true);
                                            createNewArticleForm.setData("name", newValue);
                                        });
                                    } else if (newValue && newValue.inputValue) {
                                        toggleOpen(true);
                                        createNewArticleForm.setData("name", newValue.inputValue);
                                    } else {
                                        setData("article", newValue);
                                    }
                                }}
                                options={articles}
                                freeSolo
                                selectOnFocus
                                clearOnBlur
                                handleHomeEndKeys
                            />
                            {!!getHelperTextByProperty("article") ? (
                                <FormHelperText>{getHelperTextByProperty("article")}</FormHelperText>
                            ) : (
                                <FormHelperText>Suche nach einem Artikel oder gebe die Artikelbezeichnung ein, um einen Artikel neu anzulegen.</FormHelperText>
                            )}
                        </FormControl>

                        {!! data.article ? (
                            <ASMSButton type="ghost" IconComponent={PencilIcon} onClick={() => toggleOpen(true)}>
                                Artikel bearbeiten
                            </ASMSButton>
                        ) : null}

                        <FormControl variant="filled" sx={{ width: 1 }}>
                            <TextField
                                variant="filled"
                                value={data.amount}
                                onChange={e => setData("amount", e.target.value)}
                                label="Menge"
                                inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                                error={!!getHelperTextByProperty("amount")}
                                helperText={getHelperTextByProperty("amount")}
                            />
                        </FormControl>

                        <FormControl
                            variant="filled"
                            sx={{ width: 1 }}
                            error={!!getHelperTextByProperty("storageLocation")}
                        >
                            <Autocomplete
                                inputValue={inputValueStorageLocation}
                                onInputChange={(event, newInputValue) => {
                                    setInputValueStorageLocation(newInputValue);
                                }}
                                onChange={(event, value) => {
                                    setData("storageLocation", value.id);
                                }}
                                renderInput={(params) => <TextField {...params} variant="filled" label="Lagerplatz suchen" />}
                                renderOption={(props, option) => (
                                    <li {...props} key={option.name}>{option.name}</li>
                                )}
                                getOptionLabel={option => option.name}
                                options={props.storageLocations}
                            />
                            {!!getHelperTextByProperty("storageLocation") && (
                                <FormHelperText>{getHelperTextByProperty("storageLocation")}</FormHelperText>
                            )}
                        </FormControl>

                        <FormControl
                            variant="filled"
                            sx={{ width: 1 }}
                            error={!!getHelperTextByProperty("storageType")}
                        >
                            <FormLabel>Lagertyp</FormLabel>
                            <RadioGroup
                                row
                                value={data.storageType}
                                onChange={e => setData("storageType", e.target.value)}
                            >
                                <FormControlLabel value="PALLET" control={<Radio />} label="Palette" />
                                <FormControlLabel value="PARCEL" control={<Radio />} label="Paket" />
                            </RadioGroup>
                        </FormControl>

                        <FormControl
                            variant="filled"
                            sx={{ width: 1 }}
                            error={!!getHelperTextByProperty("storageType")}
                        >
                            <MobileDatePicker
                                value={data.createdAt}
                                onChange={(newValue) => {
                                    setData("createdAt", newValue);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="filled"
                                        label="Einlagerungsdatum"
                                        helperText="Standardmäßig wird der heutige Tag als Einlagerungsdatum verwendet, alternativ kannst du ein anderes Datum auswählen."
                                    />
                                )}
                            />
                        </FormControl>
                    </div>
                </TitleContainer>

                <Dialog open={open} onClose={() => toggleOpen(false)}>
                    <DialogTitle>{isEditMode ? "Artikel bearbeiten": "Neuen Artikel anlegen"}</DialogTitle>
                    <DialogContent className="space-y-3">
                        <TextField
                            error={!!getHelperTextByProperty("name")}
                            variant="filled"
                            value={createNewArticleForm.data.name}
                            onChange={e => createNewArticleForm.setData("name", e.target.value)}
                            label="Artikelbezeichnung"
                            fullWidth
                            helperText={getHelperTextByProperty("name")}
                        />
                        <TextField
                            error={!!getHelperTextByProperty("eanNumber")}
                            variant="filled"
                            value={createNewArticleForm.data.eanNumber}
                            onChange={e => createNewArticleForm.setData("eanNumber", e.target.value)}
                            label="EAN-Nummer"
                            fullWidth
                            helperText={getHelperTextByProperty("eanNumber")}
                        />
                        <TextField
                            error={!!getHelperTextByProperty("articleNumber")}
                            variant="filled"
                            value={createNewArticleForm.data.articleNumber}
                            onChange={e => createNewArticleForm.setData("articleNumber", e.target.value)}
                            label="Artikelnummer"
                            fullWidth
                            helperText={getHelperTextByProperty("articleNumber")}
                        />
                        <TextField
                            error={!!getHelperTextByProperty("manufacturer")}
                            variant="filled"
                            value={createNewArticleForm.data.manufacturer}
                            onChange={e => createNewArticleForm.setData("manufacturer", e.target.value)}
                            label="Hersteller"
                            fullWidth
                            helperText={getHelperTextByProperty("manufacturer")}
                        />

                        <div className="flex justify-end">
                            <Button onClick={() => createOrUpdateArticle()} variant="contained" disableElevation>Speichern</Button>
                        </div>
                    </DialogContent>
                </Dialog>
            </div>
        </LocalizationProvider>
    );
}

export default WarehouseEntryForm;
